<template>
  <div class="card-item">
    <div class="user-info">
      <a :href="itemLink">
        <img
          class="user-info__avatar"
          height="25px"
          width="25px"
          :src="srcAvatar"
        />
      </a>
      <div class="user-info__wrapper">
        <span class="user-info__full-name">
          {{ itemTitle }}
          <span
            v-if="itemInfo.ldap && itemType === 'USER'"
            class="badge badge-secondary ml-1"
            style="top: -1px"
          >
            LDAP
          </span>
        </span>
        <a
          class="user-info__alias"
          :href="itemLink"
        >
          <span>{{ formatedAlias }}</span>
        </a>
      </div>
      <div
        v-if="showInvitationStatus"
        class="user-info__invite-status"
      >
        {{ $t('membersWrapper.tableItem.titles.invitationNotAccepted') }}
      </div>
      <div
        class="user-info__parent-entity"
        v-else-if="
          invitationSourceEntityLink &&
          (itemInfo.invitationSourceEntityUuid || itemInfo.invitationSourceEntityAlias)
        "
      >
        <span class="text-truncate">{{ $t('membersWrapper.table.titles.accessFrom') }}:</span>

        <a
          class="user-info__alias"
          :href="invitationSourceEntityLink"
        >
          {{ itemInfo.invitationSourceEntityAlias }}
        </a>
      </div>
    </div>
    <div class="card-actions">
      <div
        class="card-actions__selector"
        :class="{ disabled: isActionsDisabled }"
      >
        <gf-entity-members-role-selector
          v-if="roles && selectedRole"
          :selected="selectedRole"
          :options="roles"
          @role-change="onChange"
        />
      </div>

      <div class="card-actions__buttons">
        <button
          type="button"
          v-if="itemInfo.ldap && itemType === 'USER' && entityType !== 'PROJECT'"
          class="btn btn-sm btn-outline-secondary mr-2"
          @click="onOpenLdapModalWindow"
          :data-target="`unlockRole-${itemInfo.userUuid || itemInfo.uuid}`"
        >
          <i
            class="gf-icon"
            :class="itemInfo.roleAddingMethod === 'LDAP' ? 'gf-icon-lock' : 'gf-icon-lock-open'"
          ></i>
        </button>

        <span
          v-else
          class="--button-sm-empty"
        ></span>

        <button
          type="button"
          @click="onDelete"
          class="btn btn-danger btn-sm"
          :disabled="isActionsDisabled"
        >
          <i class="gf-icon gf-icon-trash"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import GfEntityMembersRoleSelector from '@/shared-modules/shared-components/wrappers/wrappers-components/entity-members-table/GfEntityMembersRoleSelector';
import HelperService from '@/shared-modules/services/helper.service';
import WrapperMessages from '@/shared-modules/shared-components/wrappers/messages/wrapper.messages';
import { invitationSourcesTypes } from '@/shared-modules/shared-components/wrappers/constants/entity.members.constants';
export default {
  name: 'GfEntityMembersTableItem',
  components: { GfEntityMembersRoleSelector },
  props: {
    itemInfo: {
      type: Object,
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: String,
      default: ''
    },
    roles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    entityType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      invitationSourceTypes: invitationSourcesTypes
    };
  },
  computed: {
    srcAvatar() {
      return this.itemInfo.avatar || '/static/image/avatar.jpg';
    },
    formatedUuid() {
      return this.itemType === 'USER' ? this.itemInfo.userUuid : this.itemInfo.uuid;
    },
    formatedAlias() {
      return this.itemType === 'USER' ? this.itemInfo.userName : this.itemInfo.alias;
    },
    formatedItemType() {
      return this.itemType.toLowerCase();
    },
    itemLinkLastPart() {
      return this.itemType === 'USER' ? `${this.formatedUuid}/profile` : this.formatedUuid;
    },
    itemLink() {
      return this.isAdmin
        ? `/admin/${this.formatedItemType}/${this.itemLinkLastPart}`
        : `/${this.formatedItemType}/${this.formatedAlias}`;
    },
    showInvitationStatus() {
      return !this.itemInfo.inviteAccepted && this.itemType === 'USER';
    },
    userFullName() {
      return ((this.itemInfo.name || '') + ' ' + (this.itemInfo.surname || '')).trim();
    },
    itemTitle() {
      return this.itemType === 'USER'
        ? this.userFullName || this.itemInfo.userName.trim()
        : this.itemInfo.title || this.itemInfo.alias;
    },
    selectedRole() {
      return Object.values(HelperService.destructureObject(this.roles))
        .flat()
        .find((role) => {
          return role.name === this.itemInfo.role;
        });
    },
    isActionsDisabled() {
      if (this.itemInfo.roleAddingMethod === 'LDAP') {
        return true;
      }

      if (this.itemType === this.invitationSourceTypes['USER']) {
        return this.itemInfo.invitationToEntitySourceType === this.invitationSourceTypes['USER'] ||
          !this.itemInfo.invitationToEntitySourceType
          ? this.itemInfo.userEntityOwner
            ? true
            : false
          : true;
      }

      return this.itemType === this.invitationSourceTypes['TEAM'] ? false : true;
    },
    invitationSourceEntityLink() {
      switch (this.itemInfo.invitationToEntitySourceType) {
        case null:
          return null;
        case this.invitationSourceTypes['USER']:
          return this.isAdmin
            ? `/admin/user/${this.itemInfo.invitationSourceEntityUuid}/profile`
            : `/user/${this.itemInfo.invitationSourceEntityAlias}`;
        case this.invitationSourceTypes['TEAM']:
          return this.isAdmin
            ? `/admin/team/${this.itemInfo.invitationSourceEntityUuid}`
            : `/team/${this.itemInfo.invitationSourceEntityAlias}`;
        case this.invitationSourceTypes['COMPANY']:
          return this.isAdmin
            ? `/admin/company/${this.itemInfo.invitationSourceEntityUuid}`
            : `/company/${this.itemInfo.invitationSourceEntityAlias}`;
        default:
          return;
      }
    }
  },
  methods: {
    onChange(data) {
      this.$emit('role-change', {
        role: data.role || data.name,
        type: this.itemType,
        itemUuid: this.formatedUuid
      });
    },
    onDelete() {
      this.$emit('delete', {
        type: this.itemType,
        uuid: this.formatedUuid,
        alias: this.formatedAlias
      });
    },
    onOpenLdapModalWindow() {
      if (!this.itemInfo.userUuid) return;
      this.$emit('open-ldap-modal', {
        uuid: this.itemInfo.userUuid,
        fullName: this.userFullName,
        username: this.formatedAlias,
        isRoleEqualLdap: this.itemInfo.roleAddingMethod === 'LDAP',
        isLdap: this.itemInfo.ldap,
        action: this.itemInfo.roleAddingMethod === 'LDAP' ? 'unlock' : 'lock'
      });
    }
  },
  i18n: {
    messages: WrapperMessages
  }
};
</script>
